import { Trash2, X } from 'lucide-react';

interface DeleteButtonProps {
  onDelete: () => void;
  onCancel: () => void;
  isPending: boolean;
  isDeleting: boolean;
  className?: string;
}

export function DeleteButton({
  onDelete,
  onCancel,
  isPending,
  isDeleting,
  className = '',
}: DeleteButtonProps) {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <button
        onClick={onDelete}
        disabled={isDeleting}
        data-ph-capture-attribute="btn-delete-confirm"
        className={`inline-flex items-center px-3 py-1 rounded-md text-sm justify-center ${
          isDeleting
            ? 'text-gray-400 cursor-not-allowed'
            : isPending
              ? 'text-red-900 bg-red-100 hover:bg-red-200'
              : 'text-red-700 hover:text-red-900'
        }`}
      >
        <Trash2 className="h-4 w-4 mr-1" />
        {isDeleting ? 'Deleting...' : isPending ? 'Confirm?' : 'Delete'}
      </button>
      {isPending && !isDeleting && (
        <button
          onClick={onCancel}
          data-ph-capture-attribute="btn-delete-cancel"
          className="text-gray-500 hover:text-gray-700"
          title="Cancel deletion"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
